export default {
  title_400: "Bad Request",
  title_401: "Authorisation Required",
  title_403: "Forbidden",
  title_404: "Not Found",
  title_408: "Request Timeout",
  title_500: "Internal Server error",
  title_501: "Not Implemented",
  title_502: "Bad Gateway",
  title_503: "Service unavailable",
  title_504: "Gateway Timeout",

  body_400_1: "Oops! Something went wrong with that action",
  body_400_2:
    "We have already been notified of the problem and will investigate. Your data is saved!",
  body_400_3: "Please try again later. If it persists, contact {url}.",
  body_401_1: "Access denied",
  body_401_2: "You need to sign in or provide valid credentials to access this resource.",
  body_401_3: "Please contact {url} for assistance.",
  body_403_1: "Inadequate permissions",
  body_403_2: "You’re not supposed to see this!",
  body_403_3: "This means you don’t have the necessary permissions do what you attempted.",
  body_403_4: "Please contact your administrator for assistance",
  body_404_1: "Oops! We couldn’t find that resource",
  body_404_2:
    "It may have been moved or deleted. Please check the URL or try navigating from the Workspace Home.",
  body_408_1: "Uh oh! We're having trouble communicating with the server right now.",
  body_408_2: "We’ve been notified about this and will investigate. Please try again later.",
  body_408_3: "You can check your systems availability {url}.",
  body_500_1: "That’s a bug.",
  body_500_2:
    "We’re very sorry about that. There’s nothing you can do about this. We have already been notified of the problem and will investigate.",
  body_500_3: "Keep track of our progress on this, {url}.",
  body_501_1: "We're sorry, but the feature you're trying to access is still in development.",
  body_501_2: "We're working on it!",
  body_502_1: "Uh oh! We're having trouble communicating with the server right now.",
  body_502_2: "We’ve been notified about this and will investigate. Please try again later.",
  body_503_1: "The server is temporarily unable to handle your request.",
  body_503_2: "We’ve been notified about this and will investigate. Please try again later.",
  body_503_3: "You can check your systems availability {url}.",
  body_504_1: "Sorry, the server took too long to respond.",
  body_504_2: "We’ve been notified about this and will investigate. Please try again later.",

  quote_400:
    "It is possible to commit no mistakes and still lose. That is not a weakness. That is life.",
  quote_401: "Ah ah ah, you didn’t say the magic word!",
  quote_403: "That’s for her eyes only.",
  quote_404: "What do you say we try that again? Yes, yes. Yes. Without the “oops”.",
  quote_408: "Ain’t nobody got time for that.",
  quote_500: "No joke for this. That... is... bad.",
  quote_501: "Are we there yet?",
  quote_502: "...the mighty rampart crumbled; the Black Gate was hurled in ruin...",
  quote_503: "Unlike some servers, S A M M Y will never spit in your soup",
  quote_504: "This is the final boarding call for S A M M Y. Please proceed to the gate.",

  url_support: "support",
  url_here: "here",
}
